import { api } from "./api";

export const CHIP_LABEL = { venues: "Venues", photographers: "Photographers", videographers: "Videographers", planners: "Planners", florists: "Florists", djs: "DJs & Music",
  caterers: "Caterers", cakes: "Cakes", beauty: "Hair & Makeup", attire: "Attire", decor: "Decor & Rentals", transport: "Transport" };

const CHUNK = 4 * 1024 * 1024;

// Uploads a photo/video in 4MB chunks; resolves to the stored /api/files URL.
export async function uploadMedia(file, onProgress) {
  if (file.size > 200 * 1024 * 1024) throw new Error("Files can be up to 200MB");
  const id = Array.from(crypto.getRandomValues(new Uint8Array(8))).map((b) => b.toString(16).padStart(2, "0")).join("");
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let last = null;
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    fd.append("upload_id", id); fd.append("index", String(i)); fd.append("total", String(total)); fd.append("content_type", file.type || "video/mp4");
    fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    last = (await api.post("/social/media/chunk", fd)).data;
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return last.url;
}

export const money = (n) => (n ? `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}` : "Custom");
